// =============================================================================
// Steps-method accordion (mockup page 2): every method card collapsed by
// default, each card toggles independently (opening one leaves the others
// as they are); without JS every card stays expanded.
// =============================================================================

function init() {
	document.querySelectorAll(".aa-methods").forEach((list) => {
		const cards = Array.from(list.querySelectorAll(".aa-method"));
		if (!cards.length) return;

		const set = (card, open) => {
			card.classList.toggle("is-open", open);
			const btn = card.querySelector(".aa-method__toggle");
			if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
		};

		list.classList.add("is-accordion");
		cards.forEach((card) => set(card, false));

		cards.forEach((card) => {
			const btn = card.querySelector(".aa-method__toggle");
			if (!btn) return;
			btn.addEventListener("click", () => {
				set(card, !card.classList.contains("is-open"));
			});
		});
	});
}

if ("loading" === document.readyState) {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
